let products = [
  {
    id: 1, 
    title: '合规', 
    title_e: 'Compliance',
    messages: [
      {id: 1, text: '江苏省市场监督局'},
      {id: 2, text: '战略合作单位'}
      // {id: 2, text: '打通江苏省工商税务系统，可承载集群注册'},
      // {id: 3, text: '政企联动，互联网+监管规范用工市场'}
    ], 
    icon: 'https://static.weibangong.com/files/5d1ad056633c3d4163ef9c78-big'
  },
  {
    id: 2, 
    title: '安全', 
    title_e: 'Confidential',
    messages: [
      {id: 1, text: '银行托管更放心'},
      {id: 2, text: '政府监管更合规'},
      // {id: 1, text: '江银行托管，保障资金安全'},
      // {id: 2, text: '政府监管，符合法律法规'},
    ], 
    icon: 'https://static.weibangong.com/files/5d1ad057633c3d4163ef9c79-big'
  },
  {
    id: 3, 
    title: '专业', 
    title_e: 'Professional',
    messages: [
      {id: 1, text: '强大的互联网团队支持'},
      {id: 2, text: '全直营的线下服务网点'},
    ], 
    icon: 'https://static.weibangong.com/files/5d1ad057633c3d4163ef9c7a-big'
  },
  {
    id: 4, 
    title: '便捷', 
    title_e: 'Convenient',
    messages: [
      {id: 1, text: '全程移动端线上操作'},
      {id: 2, text: 'T+1获得个体户营业执照'},
      // {id: 3, text: '企业一键导入名单，系统批量审核处理通过'}
    ], 
    icon: 'https://static.weibangong.com/files/5d1ad058633c3d4163ef9c7d-big'
  },
]

export default [
  {
    url: '/wck/website/products',
    type: 'post',
    response: config => {
      return {
        code: 200,
        list: products,
        success: 'success'
      }
    }
  },
]